// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"88c75559","235":"375c8d4f","307":"0c304aa3","383":"f0d1e018","427":"e2fdc2e4","453":"e1ea8cda","489":"5965fcb3","572":"f4b0cfba","669":"9d75f9ad","706":"6ca38c29","723":"b71224fd","929":"555547da"}[chunkId] + ".chunk.js";
};